import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { WorkflowModel } from '@app/core/models/workflows/workflow.model';
import { WorkflowService } from '@app/core/services/workflow.service';


@Injectable({ providedIn: 'root' })
export class WorkflowsResolver  {
  constructor(private workflowService: WorkflowService) { }

  resolve(): Observable<WorkflowModel[]> | Promise<WorkflowModel[]> | WorkflowModel[] {

    return this.workflowService.getWorkflows().pipe(
      catchError(this.handleError)
    );
  }

  private handleError(err: HttpErrorResponse | any) {
    console.error('An error occurred', err);
    return throwError(err.message || err);
  }
}
